<div class="combo-chart-container">
  <div class="chart-section" [ngClass]="{'no-border': noBorder}">
    <div class="chart-header">
      <div class="chart-title-section">
        <h4 class="chart-title">{{ competitorAnalysisData ? competitorAnalysisData.title : 'AI Platform Performance
          Analysis' }} </h4>
        <p class="chart-subtitle">{{ competitorAnalysisData ? competitorAnalysisData.subtitle : 'Overall scores (bars)
          and individual AI platform trends (lines)' }}</p>
      </div>

      <!-- Custom Legend positioned at top-right -->
      <div class="combo-legend top-right" *ngIf="processedBarData && processedBarData.length > 0">
        <!-- Bar Legend - First University -->
        <div class="legend-item" *ngIf="firstUniversityName">
          <div class="legend-color bar-color"></div>
          <span>{{ firstUniversityName }}</span>
        </div>
        <!-- Line Legends - Other Universities -->
        <div class="legend-item" *ngFor="let lineData of processedLineData">
          <div class="legend-color line-color" [style.background-color]="getLineColor(lineData.name)"></div>
          <span>{{ lineData.name }}</span>
        </div>
      </div>
    </div>

    <!-- Custom Combo Chart Implementation -->
    <div class="combo-chart-wrapper">
      <!-- Debug Info -->


      <!-- Bar Chart for Overall Scores -->
      <div class="bar-chart-layer" *ngIf="processedBarData && processedBarData.length > 0">
        <ngx-charts-bar-vertical [view]="view" [scheme]="comboBarScheme" [results]="processedBarData"
          [xAxis]="true" [yAxis]="true" [legend]="false" [animations]="animations" [gradient]="false"
          [xAxisLabel]="xAxisLabel" [yAxisLabel]="yAxisLabel" [showXAxisLabel]="true" [showYAxisLabel]="true"
          [showGridLines]="showGridLines" [roundDomains]="false" [tooltipDisabled]="false" [barPadding]="0.8">
        </ngx-charts-bar-vertical>
      </div>

      <!-- Line Chart Overlay for Competitors -->
      <div class="line-chart-layer" *ngIf="processedLineData && processedLineData.length > 0">
        <ngx-charts-line-chart [view]="view" [scheme]="lineChartScheme" [results]="processedLineData"
          [xAxis]="false" [yAxis]="false" [legend]="false" [animations]="animations" [gradient]="false"
          [showXAxisLabel]="false" [showYAxisLabel]="false" [showGridLines]="false" [roundDomains]="false"
          [tooltipDisabled]="false">
        </ngx-charts-line-chart>
      </div>
    </div>
  </div>
</div>
